import { TranslationObject } from '@ngx-translate/core';
import { Tag } from '@lib.core/entities/tag/tag';
import { LoggerService } from '@lib.core/logger/logger.service';
import { AspectSummary } from '@lib.core/entities/indicator/indicator-summary';
import { SourceDTO, newSourceFromDto } from '@lib.resources/source/dtos/source';
import { TopicDTO, newTopicFromDto } from '@lib.resources/topic/dtos/topic';
import { TagDTO, newTagFromDto } from '@lib.resources/tag/dtos/tag';
import { KPIDTO } from '@lib.resources/indicator/dtos/kpi';
import { AspectTypeDTO, newAspectTypeFromDto } from '@lib.resources/indicator-type/dtos/indicator-type-dto';

export class AspectSummaryDTO {
  title!: TranslationObject;
  description?: TranslationObject;
  brief?: TranslationObject;
  type!: AspectTypeDTO;
  kpi?: KPIDTO;
  kpiSecondary?: KPIDTO;
  source?: SourceDTO[];
  topic?: TopicDTO;
  tags?: TagDTO[];
  lastUpdatedAt!: string;

  static toAspectSummary(aspectSummaryDTO: AspectSummaryDTO): AspectSummary {
    const logger = LoggerService.getLoggerService();
    const { title, description, brief, type, kpi, kpiSecondary, source, topic, lastUpdatedAt, tags } = aspectSummaryDTO;
    const [topicEntity, err] = newTopicFromDto(topic);
    if (err) {
      logger.error(err);
    }
    const tagEntities: Tag[] = [];
    tags?.forEach((tagDTO) => {
      const [tagEntity, err] = newTagFromDto(tagDTO);
      if (err) {
        logger.error(err);
      } else {
        tagEntities.push(tagEntity);
      }
    });
    return new AspectSummary(
      title,
      description,
      brief,
      newAspectTypeFromDto(type),
      source?.map(source => newSourceFromDto(source)).filter(([, error]) => error === null).map(([source,]) => source) ?? [],
      topicEntity,
      new Date(Date.parse(lastUpdatedAt)),
      tagEntities.length === 0 ? undefined : tagEntities,
      kpi && KPIDTO.toKPI(kpi),
      kpiSecondary && KPIDTO.toKPI(kpiSecondary)
    );
  }
}
